/**
 * The `returnTo` of a review started from another page (pedagogy spec §6.3.4 hand-offs): the
 * summary's "Tillbaka till dagens pass" navigates to it. It comes from the URL, so it is checked
 * before use: a single leading slash (never `//host` or `/\host`) and a path on the allow-list,
 * optionally with a query or fragment (the runner's `?done=`).
 */
const ALLOWED_PATHS: readonly string[] = ["/practice/today", "/flashcards"];

/** `raw` when it is a safe in-app path to return to, otherwise null. */
export function safeReturnTo(raw: string | null | undefined): string | null {
  if (!raw || !/^\/(?![/\\])/.test(raw)) return null;
  const path = raw.split(/[?#]/, 1)[0] ?? "";
  return ALLOWED_PATHS.includes(path) ? raw : null;
}

/** `limit` of a mixed-review URL: a whole number 1 to 100, else the default of 30. */
export function mixedLimit(raw: string | null): number {
  const n = Number(raw);
  return raw !== null && Number.isInteger(n) && n >= 1 && n <= 100 ? n : 30;
}
